import { props, state } from 'cerebral/tags'
import isValidField from 'modules/Media/factories/isValidField'
import saveSize from '../actions/saveSize'

export default [
  isValidField(state`${props`path`}.form.${props`name`}`),
  {
    true: [saveSize],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/onSaveSize.js